<template>
  <div class="passes-user-action" v-click-outside="close" @mouseleave="close">
    <button
      class="passes-user-action__icon"
      :class="{ 'is-active': isOpen }"
      @mouseenter="open"
      @click="open"
    >
      <icon :name="icon" />
    </button>

    <div
      class="passes-user-action__box"
      @click="close"
      :class="{ 'is-open': isOpen }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "PassesUserAction",

  props: {
    icon: String
  },

  data() {
    return { isOpen: false };
  },

  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";

.passes-user-action {
  position: relative;

  &__icon {
    @include button-clean();

    cursor: pointer;

    .svg-icon {
      width: 16px;
      height: 16px;

      color: #767676;
    }

    &.is-active .svg-icon {
      color: #009ee3;
    }
  }

  &__box {
    &:not(.is-open) {
      display: none;
    }

    position: absolute;

    top: 15px;
    right: 0;

    z-index: 2;

    width: 210px;
    overflow: hidden;

    border-radius: 2px;

    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);

    background-color: #fff;

    > * {
      border: 0;
      background: none;
      outline: none;
      cursor: pointer;
      width: 100%;
      box-sizing: border-box;
      padding: 10px 16px;
      font-size: 13px;
      line-height: 1.54;
      color: #000;
      text-align: left;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      display: block;

      .svg-icon {
        margin-right: 5px;
        transform: translateY(4px);

        color: #767676;
      }

      &:hover {
        background-color: #009ee3;
        color: #fff;
      }

      &:hover .svg-icon {
        color: #fff;
      }
    }
  }
}
</style>
